module.exports = __webpack_public_path__ + "media/newstyle/images/article_shortcut-3725a6c7859c500310aed9809461472f.svg";